import { gql } from '@apollo/client/core'
import { projectAccessFragment } from '../projects/api/fragments'

export const invoiceFragment = gql`
  fragment InvoiceProps on Invoice {
    id
    designer {
      id
    }
    amountCents
    refundedCents
    designerFeeCents
    netAmountCents
    paidAt
    paidType
    createdAt
    deletedAt
  }
`

export const fullInvoiceFragment = gql`
  ${invoiceFragment}
  fragment FullInvoiceProps on Invoice {
    ...InvoiceProps
    client {
      id
      firstName
      lastName
      email
    }
    service {
      id
      name
    }
    amount
    refunded
    designerFee
    netAmount
    status
    paymentType
    description
  }
`

export const clientPropsFragment = gql`
  ${invoiceFragment}
  ${projectAccessFragment}
  fragment ClientProps on Client {
    id
    firstName
    lastName
    email
    sign
    projects {
      id
      name
      cover {
        imageUrl
      }
      access {
        ...ProjectAccessProps
      }
      status
    }
    invoices {
      ...InvoiceProps
    }
  }
`

export const clientFullInvoicesPropsFragment = gql`
  ${fullInvoiceFragment}
  ${projectAccessFragment}
  fragment ClientFullInvoicesProps on Client {
    id
    firstName
    lastName
    email
    sign
    projects {
      id
      name
      cover {
        imageUrl
      }
      access {
        ...ProjectAccessProps
      }
      status
    }
    invoices {
      ...FullInvoiceProps
    }
  }
`
